export default __webpack_public_path__ + "static/media/c49dff427b756aab.e135ddc5078cff41bf82935b17742a69.svg";